import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const convertToDataTable = (data: IGetModem[]): IGetModem[] => {
  const dataTableData: IGetModem[] = [];

  if(!data) return dataTableData;

  data.map(d => {
    dataTableData.push(d)
  })

  return dataTableData;
}

const getAllModemsList = async (): Promise<IGetModem[]> => {
  const response =  await axiosDefaultApi.get(`/api/Modems/GetModems` );
  return convertToDataTable(response as unknown as IGetModem[]);
};

type QueryFnType = typeof getAllModemsList;

type UseGetAllModemsListOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllModemsList = ({ config }: UseGetAllModemsListOptions = {} ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllModemsList'],
    queryFn: () => getAllModemsList(),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};